import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey:            "AIzaSyCCQzfXm8utcOGX8chkI8a69A7GzOnOnho",
  authDomain:        "tugestorfinanciero.firebaseapp.com",
  projectId:         "tugestorfinanciero",
  storageBucket:     "tugestorfinanciero.firebasestorage.app",
  messagingSenderId: "509803361755",
  appId:             "1:509803361755:web:4fbee79053eca5e3ba23fe"
};

const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);

export const messagingPromise = (async () => {
  try {
    const supported = await isSupported();
    if (supported) return getMessaging(app);
    return null;
  } catch {
    return null;
  }
})();

export default app;
